module.exports = __webpack_public_path__ + "static/media/error-icon.1dab480d.svg";